import React from "react";

interface DashboardCardProps {
  icon: React.ReactNode;
  label: string;
  value?: number;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  icon,
  label,
  value,
}) => {
  return (
    <div className="flex flex-col w-full">
      <div className="flex items-center gap-4 p-4 bg-white shadow-md rounded-md">
        <div
          className="flex justify-center items-center text-white text-6xl w-[40px] h-[40px] rounded-md"
          style={{ backgroundColor: "var(--primary-color)" }}
        >
          {icon}
        </div>
        <div>
          <p className="text-gray-600 text-md font-medium md:text-sm">{label}</p>
          <p className="text-gray-900 text-3xl font-bold">{value}</p>
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;
